import { api } from 'services/companiesApi';

type CampaignResultDetailsProps = {
	campaignId: string;
	questionnaireId: string;
	branchOfficeId?: string;
	sector?: string;
};

export const getCampaignResultDetails = ({
	campaignId,
	branchOfficeId,
	questionnaireId,
	sector,
}: CampaignResultDetailsProps) => {
	const branchOfficeParam = branchOfficeId ? { branchOfficeId } : {};
	const questionnaireParam = questionnaireId ? { questionnaireId } : {};
	const sectorParam = sector ? { sector } : {};

	return api.get(`/campaigns/${campaignId}/result`, {
		params: {
			...branchOfficeParam,
			...questionnaireParam,
			...sectorParam,
		},
	});
};
